import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Nav from "./Nav";
import BuySidebar from "./header/BuySidebar";
// import BuyTokenButton from "./header/BuyTokenButton";
import AccessDAppLink from "./header/AccessDAppLink";

import logo from "../assets/img/logo.webp";
import { Link } from "react-router-dom";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <>
      <header className="fixed top-0 w-full h-20 flex items-center justify-between px-4 sm:px-2 bg-[var(--color-secondary-dark)] text-white z-50 shadow-[0_4px_10px_rgba(0,0,0,0.5)] backdrop-blur-md">
        {/* Left: Logo + Nav */}
        <div className="flex items-center gap-4">
          <Link to="/">
            <div className="flex items-center gap-2">
              <img
                src={logo}
                alt="UcWaves Logo"
                className="h-10 w-auto hidden sm:block"
              />
            </div>
          </Link>
          <Nav />
        </div>

        {/* Right: desktop buttons or burger */}
        <div className="flex items-center gap-1">
          {/* Desktop */}
          <div className="hidden sm:flex items-center gap-1">
            {/* <BuyTokenButton /> */}
            <BuySidebar />
            <AccessDAppLink />
          </div>

          {/* Mobile burger button */}
          <button
            onClick={() => setIsMenuOpen(true)}
            className="sm:hidden text-3xl p-2 hover:text-[var(--color-primary)] transition-transform hover:scale-110"
            aria-label="Open mobile menu"
          >
            ☰
          </button>
        </div>
      </header>

      {/* Mobile menu */}
      <AnimatePresence>
        {isMenuOpen && (
          <motion.div
            key="mobile-menu"
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ type: "tween", duration: 0.3 }}
            className="fixed top-0 right-0 w-3/4 max-w-xs h-screen bg-red-800 text-white z-50 shadow-lg flex flex-col"
          >
            {/* Top bar of mobile menu */}
            <div className="flex flex-col items-center px-4 py-4 border-b border-white/20">
              <img
                src={logo}
                alt="UcWaves Logo"
                className="h-12 w-auto mb-2 sm:hidden"
              />
              <div className="flex justify-between items-center w-full">
                <h2 className="text-lg font-bold">Menu</h2>
                <button
                  onClick={() => setIsMenuOpen(false)}
                  aria-label="Close mobile menu"
                  className="text-2xl hover:text-[var(--color-primary)]"
                >
                  ✕
                </button>
              </div>
            </div>

            {/* Content of mobile menu */}
            <div className="flex flex-col gap-6 px-6 py-8">
              {/* <BuyTokenButton /> */}
              <BuySidebar />
              <AccessDAppLink />
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Header;
